<template>
  <div class="index">
    <FloatBall @goNextNav="handleShowNav" />
    <toOtherNav @handleCloseMask="handleCloseMask" v-show="isShowNav" />
    <Header
      :counts="counts"
      :countsMap="countsMap"
      :legends.sync="legends"
      id="headers"
    ></Header>
    <div class="blank">blank</div>
    <TimeLine :timelineData="timelineSetData"></TimeLine>
    <div class="member">
      <div class="text">这场全民战“疫”史</div>
      <div class="text">每一个关键节点都值得我们铭记</div>
    </div>
    <div class="bottom">
      <img src="../assets/bottom.jpg" style="width: 100%" />
    </div>
    <div class="pointer">
      <img class="pointer-point" src="../assets/favicon.png" />
    </div>
  </div>
</template>

<script>
import Header from "./Header.vue";
import TimeLine from "./TimeLine.vue";
import FloatBall from "./FloatBall";
import toOtherNav from "./toOtherNav";

export default {
  name: "Index",
  components: {
    Header,
    TimeLine,
    FloatBall,
    toOtherNav,
  },
  data() {
    return {
      isShowNav: false,
      counts: {
        definite: 0,
        suspect: 0,
        death: 0,
        recovery: 0,
      },
      countsMap: {},
      timelineData: {},
      timelineSetData: {},
      legends: {
        red: true,
        green: true,
        blue: true,
        purple: true,
        yellow: true,
      },
    };
  },
  created() {
    let _this = this;
    this.$axios.get("data.json").then(function(response) {
      _this.timelineData = response.data;
      _this.timelineSetData = response.data;
    });
    this.$axios.get("count.json").then(function(response) {
      _this.countsMap = response.data;
    });
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    handleScroll() {},

    handleShowNav() {
      this.isShowNav = true;
    },
    handleCloseMask() {
      this.isShowNav = false;
    },
  },
  watch: {
    legends: {
      deep: true,
      handler: function(val) {
        let all = {};
        for (let key in this.timelineData) {
          let result = {};
          if (this.timelineData[key].left && val.red) {
            result["left"] = this.timelineData[key].left;
          }

          let events = [];
          if (this.timelineData[key].right) {
            for (let right of this.timelineData[key].right) {
              if (val[right.type]) {
                events.push(right);
              }
            }
          }

          if (events.length > 0 || result["left"]) {
            result["right"] = events;
            result["level"] = this.timelineData[key].level;
            all[key] = result;
          }
        }
        this.timelineSetData = {};
        this.timelineSetData = Object.assign({}, this.timelineSetData, all);
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.index {
  position: relative;
}
.member {
  height: 190px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.text {
  font-size: 24px;
  margin-bottom: 20px;
}

.blank {
  height: 256px;
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.pointer {
  position: fixed;
  z-index: 998;
  top: 178px;
  width: 100%;
  text-align: center;
}

.pointer-point {
  width: 20px;
  height: 20px;
  /*top: 0px;*/
  left: 0px;
  right: 0px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 50%;

  /*background:#2596d5;*/
}
</style>
